import { notification } from "antd";
import type { NotificationPlacement } from "antd/es/notification/interface";
import { ReactNode } from "react";

interface IAppNotification {
  msg?: string;
  desc?: string | ReactNode;
  placement?: NotificationPlacement;
  duration?: number | null;
  onClick?: () => void;
  showProgress?: boolean;
}

export default class AppNotification {
  private static notify(
    type: "success" | "error" | "info" | "warning",
    { msg, desc, placement = "topRight", duration = 4, onClick
    }: IAppNotification
  ): void {
    notification[type]({
      message: msg || "",
      description: desc || "",
      placement,
      duration,
      onClick,
      showProgress: true,
    });
  }

  static success(args: IAppNotification): void {
    this.notify("success", args);
  }

  static error(args: IAppNotification): void {
    this.notify("error", args);
  }

  static info(args: IAppNotification): void {
    this.notify("info", args);
  }

  static warning(args: IAppNotification): void {
    this.notify("warning", args);
  }
}
